module.exports = __webpack_public_path__ + "static/assets/8e5e28b23ba596614a60d319d9c64165.svg";